<template>
    <div class="ah-voucher-status-label" :class="{finish: status === 1}">
        <span v-if="status === 1">已核准</span>
        <span v-if="status === 0">待辦</span>
    </div>
</template>
<script>
export default {
    props: {
        status: {
            type: Number,
            default: 0,
        },
    },
};
</script>
<style lang="scss">
.ah-voucher-status-label {
    display: inline-block;
    font-size: 9pt;
    background-color: #f4f4f4;
    color: #888;
    padding: 0 8px;
    line-height: 22px;
    height: 22px;
    border-radius: 4px;

    &.finish {
        background-color: #def5d6;
        color: #0baa1b;
    }
}
</style>
